import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { BreakpointObserver } from '@angular/cdk/layout';

type SnackType = 'success' | 'warning' | 'error';

@Injectable({ providedIn: 'root' })
export class NotificationService {

  constructor(
    private snackBar: MatSnackBar,
    private bp: BreakpointObserver
  ) {}

  show(message: string, type: SnackType = 'success', duration?): void {
    const isHandset = this.bp.isMatched('(max-width: 599px)');

    const config: MatSnackBarConfig = {
      duration,
      verticalPosition: 'top',
      horizontalPosition: isHandset ? 'center' : 'right',
      panelClass: ['custom-snack', `snack-${type}`]
    };

    this.snackBar.open(message, 'X', config);
  }
}